module.exports = __webpack_public_path__ + "static/media/faved-business-icon.6dd3dac4.svg";